import type { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { ErrorBoundary } from '../components/ErrorMessage';
import './shell.css';

/** Shell-less layout for onboarding, /kamera and /dela: centred column, no navigation. */
export function BareLayout({ children, narrow = true }: { children?: ReactNode; narrow?: boolean | undefined }) {
  return (
    <div className={narrow ? 'bare-layout bare-layout-narrow' : 'bare-layout'}>
      <main id="main" className="bare-main" tabIndex={-1}>
        <ErrorBoundary>{children ?? <Outlet />}</ErrorBoundary>
      </main>
    </div>
  );
}
